import Vue from "vue";
import AOS from 'aos'
import 'aos/dist/aos.css'

import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

//  directive for global components
Vue.directive('focus', {
    inserted: function (el) {
        el.focus();
    }
});

//global filter or pipe
Vue.filter("numberFormat", function (value) {

    //remove zero
    if (value == 0) {
        return ''
    }
    // 1000 = 1k or 2000 = 2k
    if (value > 999) {
        return value.toString().slice(0, 1) + "." + value.toString().slice(1, 2) + " k"
    }
    return value
});

new Vue({
    created() {
        AOS.init()
    },
    router,
    store,
    render: h => h(App)
}).$mount("#app");
